import { DateTime } from 'luxon';

import { DateHelper } from '../helpers/DateHelper';

class InstallationOption {
  constructor(params) {
    this.id = `${params.date}-${params.startHour}-${params.endHour}`;
    this.date = DateTime.fromISO(params.date);
    this.extraCost = params.extraCost;
    this.installationAmount = params.installationAmount;
    this.startHour = params.startHour;
    this.startHourString = DateHelper.militaryHourToString(this.startHour);
    this.endHour = params.endHour;
    this.endHourString = DateHelper.militaryHourToString(this.endHour);
  }
}

export { InstallationOption };



// WEBPACK FOOTER //
// ./src/models/InstallationOption.js